"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableArray = void 0;
class ObservableArray {
    constructor(options = {}) {
        const { initialData = [], onChanged } = options;
        this.target = Array.from(initialData);
        this.onChanged = onChanged;
        this.proxy = this.createProxy(this.target);
    }
    notifyChanged() {
        if (this.onChanged) {
            this.onChanged(this.target);
        }
    }
    createProxy(target) {
        const self = this;
        return new Proxy(target, {
            get(target, prop, receiver) {
                if (prop === "push") {
                    return (...items) => {
                        const result = Array.prototype.push.apply(target, items);
                        self.notifyChanged();
                        return result;
                    };
                }
                if (prop === "pop") {
                    return () => {
                        const result = Array.prototype.pop.call(target);
                        self.notifyChanged();
                        return result;
                    };
                }
                if (["splice", "shift", "unshift", "sort", "reverse"].includes(String(prop))) {
                    return () => {
                        throw new Error(`${String(prop)} not allowed`);
                    };
                }
                return Reflect.get(target, prop, receiver);
            },
            // block direct index assignment, e.g. arr[0] = ...
            set() {
                throw new Error("Direct assignment is not allowed.");
            },
        });
    }
    /** Get the array-like view to expose publicly */
    get value() {
        return this.proxy;
    }
    /**
     * Replace the entire contents in one go.
     */
    setData(newData) {
        this.target.length = 0;
        this.target.push(...newData);
        this.notifyChanged();
    }
    /** Change the callback if needed */
    setOnChanged(callback) {
        this.onChanged = callback;
    }
}
exports.ObservableArray = ObservableArray;
//# sourceMappingURL=ObservableArray.js.map